import { S } from './SocialIcon.styles';
import type { SocialIconProps } from './SocialIcon.types';
import { DB_KEY_TO_ICON, SOCIAL_ICON_MAP } from './socialIconMap';

export const SocialIcon = ({ profileKey, url, guideIdPrefix }: SocialIconProps) => {
  const iconKey = DB_KEY_TO_ICON[profileKey];
  const config = iconKey ? SOCIAL_ICON_MAP[iconKey] : undefined;
  if (!config) return null;

  return (
    <S.Text
      data-guide-id={`${guideIdPrefix}-social-${config.alt.toLowerCase()}`}
      href={url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      aria-label={config.alt}
    >
      <S.Icon viewBox="0 0 24 24" aria-hidden="true">
        <path d={config.path} fill="currentColor" />
      </S.Icon>
    </S.Text>
  );
};
